module.exports = __webpack_public_path__ + "static/media/logo_gestor_bacias.becdd6aa.png";